import {
    TOGGLE_DRAWER,
    SHOW_ARRIVAL_TIME_DIALOG,
    HIDE_ARRIVAL_TIME_DIALOG,
    SET_THEME,
    CHECK_FOR_EXPIRED_ITEMS,
    SET_ORDER_DETAIL_TYPE
} from 'constants/actionTypes';

export const toggleDrawer = (id, isOpen = null) => ({type: TOGGLE_DRAWER, id, isOpen});
export const showArrivalTimeDialog = (userId) => ({type: SHOW_ARRIVAL_TIME_DIALOG, userId});
export const hideArrivalTimeDialog = (userId) => ({type: HIDE_ARRIVAL_TIME_DIALOG, userId});
export const setTheme = (theme) => ({type: SET_THEME, theme});
export const checkForExpiredItems = () => ({type: CHECK_FOR_EXPIRED_ITEMS});
export const setOrderDetailType = (orderDetailType) => ({type: SET_ORDER_DETAIL_TYPE, orderDetailType});


// WEBPACK FOOTER //
// ./src/actions/siteActions.js